import Vue from 'vue';
import store from './store';
import router from './router';
import ajax from '@/services/base.service.js';

//-- Meta rewriting
import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

//-- Basic bootstrap
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

//import 'font-awesome/css/font-awesome.min.css';
import './mixins';
import './thirdparty';
import './scss/core.scss';

//-- Import font-awesome css for the tables icons vue-table
import 'font-awesome/css/font-awesome.min.css'

import AppLayout from './layout/Index.vue';

Vue.config.productionTip = false;

const API = {
    install(Vue, options) {
        Vue.prototype.$AJAX = ajax;
    }
};

Vue.use(API);

(() => new Vue({
    name: 'Root',
    template: '<AppLayout />',
    components: { 
        AppLayout , 
    },
    el: '#app',
    router,
    store,
    mounted() {
        //console.log(router)
        router.beforeEach((to, from, next) => {
            //-- Rewrite title for admin               
            if (to.meta.front === false)
                this.$updatePageTitle(to, from, next);
              next();
        })
        
        router.afterEach((to, from, next) => {
            //console.log("ROUTER!!"+to.meta);
            if (to.meta.auth === true)
            {
                //console.log(to.meta);
                this.$checkAuth();
            }
            if (to.meta.front === true)
            {
                //-- Check menu expanded or collapsed
                this.$store.state.menuFrontExpanded = to.meta.menu;
                //--Check if a specific language is asked
                if (this.$checkNull(this.$route.params.getLng)) this.$store.state.lngFront = this.$route.params.getLng;
                
                //-- Add lang in url (for copy/paste)
                this.$nextTick(() => {
                    //console.log("rewrite url" + this.$route.path);
                    //this.$changeLngUrl();
                });
            }
        });

        //-- Adding header for xht USED FOR uploading the images / files
        XMLHttpRequest.prototype.origOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open   = function () {
            this.origOpen.apply(this, arguments);
            //this.setRequestHeader('X-TOKEN', 'the token');
            this.withCredentials = true;
        };

        //-- Clearing array izi
        Array.prototype.clear = function() {
            while (this.length > 0) {
                this.pop();
            } // Fastest
        };

        //-- Used to compare date in an array (find doesn't work)
        Array.prototype.indexOfDate = function (date) {
            for (var i = 0; i < this.length; i++) {
                if (+this[i] === +date) return i;
            };
            return -1;
        };
        

    }
}))();



// WEBPACK FOOTER //
// ./src/app.init.js